<template>
  <v-container grid-list-xs class="d-flex flex-column justify-center align-center login-section">
    <v-card class="card">
      <v-card-title
        primary-title
        class="accentDarkBlue white--text title font-weight-light login-title"
      >Masuk</v-card-title>

      <v-container grid-list-xs class="card-body">
        <v-form class="form" ref="form" v-on:submit.prevent>
          <v-text-field
            label="Username"
            v-model="username"
            :rules="[v => !!v || 'Mohon isi username']"
            @keyup.enter.native="login"
          ></v-text-field>

          <v-text-field
            label="Password"
            v-model="password"
            type="password"
            :rules="[v => !!v || 'Mohon isi password']"
            @keyup.enter.native="login"
          ></v-text-field>

          <center class="mt-5">
            <p v-if="error" class="red--text caption">{{ error }}</p>

            <v-btn color="accentDarkBlue white--text " @click="login">Masuk</v-btn>
          </center>
        </v-form>
      </v-container>
    </v-card>
  </v-container>
</template>


<script>
import axios from "axios";
import { EventBus } from "../event-bus";

export default {
  data: () => ({
    username: "",
    password: "",
    error: ""
  }),
  methods: {
    login() {
      EventBus.$emit("startLoading");

      if (this.$refs.form.validate()) {
        axios
          .post(`${this.$api}/login`, {
            username: this.username,
            password: this.password,
            role: "admin"
          })
          .then(response => {
            if (response.data.STATUS == "ERROR") {
              this.error = response.data.MESSAGE;

              EventBus.$emit("stopLoading");
            } else {
              localStorage.setItem("token", response.data.PAYLOAD.u_login_token);
              localStorage.setItem("id", response.data.PAYLOAD.u_id);
              localStorage.setItem('role', response.data.PAYLOAD.u_role);

              EventBus.$emit("stopLoading");
              this.$router.push({ name: "home" });
            }
          });
      }
    }
  }
};
</script>



<style scoped>
.login-section {
  min-height: 80vh;
}

.login-title {
  font-family: "Montserrat", sans-serif !important;
}

.card-body {
  padding: 30px;
}

.form {
  width: 300px;
}

.icon-img {
  width: 20px;
}

@media screen and (max-width: 450px) {
  .card {
    width: 90%;
  }

  .form {
    width: 100%;
    margin: 0 auto;
  }

  .btn-block {
    font-size: 0.65rem !important;
  }

  .login-section {
    height: 100vh;
  }
}

@media screen and (max-width: 400px) {
  .btn-block {
    font-size: 0.55rem !important;
  }
}

@media screen and (max-width: 350px) {
  .btn-block {
    font-size: 0.45rem !important;
  }
}
</style>